import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { drawDOM, exportImage, exportPDF } from "@progress/kendo-drawing";
import * as moment from "moment";
import { saveAs } from "@progress/kendo-file-saver";
import { Window } from "@progress/kendo-react-dialogs";
import { Dropdown } from "react-bootstrap";
import { EditorUtils } from "@progress/kendo-react-editor";
import TextNarrative from "./Dashboard/TextNarrative";
import SkeletonReport from "./Dashboard/SkeletonReport";
import ViewActionRiskDataset from "./Dashboard/ViewActionRiskDataset";
import AddToCart from "./Tenant/AddToCart";
import Api from "../Services/Api";
import Images from "../Assets/Images";
import TextNarrativeExport from "./Dashboard/TextNarrativeExport";
import ReportUpdate from "./Dashboard/ReportUpdate";

export default class TaskKPITileChart extends Component {
  _chart;
  _chartTemp;
  _editor;

  constructor(props) {
    super(props);
    this.state = {
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      title: "",
      showAddToCart: false,
      isReportLoaded: false,
      chartData: {},
      isHidden: false
    };
    this._editor = React.createRef();
  }

  componentDidMount = () => {
    if (this.props.dashboardId && this.props.reportId && !this.props.chartInputs) {
      this.fetchReportsByPagination(this.props.dashboardId, this.props.reportId);
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true
      });
      this.onInit(this.props.chartInputs);
    }
  }
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true
        });
        this.onInit(response.chartData[0]);
        this.onPDFExportClick("INIT");

        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true
      });
    }
  };

  onInit = (chartData) => {
    try {
      this.setState({
        ...this.state,
        taskActionsMetricsResponse: chartData.taskActionsMetricsResponse,
        tasksMetricsResponse: chartData.tasksMetricsResponse,
        chartData: chartData ? chartData : {},
        isReportLoaded: true
      });
    } catch (err) {
      console.log(err);
    }
  };

  getHtml = () => {
    let htmlvalue = "";
    if (this._editor.current) {
      const view = this._editor.current.view;
      if (view) {
        htmlvalue = EditorUtils.getHtml(view.state);
      }
    }
    return htmlvalue;
  };

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId || this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };
  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
    let htmlData = this.getHtml();
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };

  shareFile = (widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData?.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);
    setTimeout(async () => {
      drawDOM(gridElement, {
        //  paperSize: "A4",
        landscape: true,
        title: this.state.title + " " + CreatedDate,
      })
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataURI) => {
          this.sendMail(dataURI, widgetId);
          // console.log(dataUri.split(";base64,")[1]);
        });
    }, 1000);
  };

  sendMail = async (dataURL, widgetId) => {
    let widgetName = this.state.chartData
      ? this.state.chartData?.widgetName
      : "Bar-chart";
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");

    var file = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    this.setState({ ...this.state, loader: true });
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  onImageExportClick = async () => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "KPI";
    let chartId = this.state.chartData?.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);

    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }

    // Function to recursively set background to transparent for all elements
    const makeTransparent = (element, originalStyles, prefix) => {
      // Store original background
      originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
      originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

      // Set background to transparent
      element.style.backgroundColor = "transparent";
      element.style.backgroundImage = "none";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        makeTransparent(child, originalStyles, `${prefix}_${index}`);
      });

      return originalStyles;
    };

    // Function to restore original backgrounds
    const restoreBackgrounds = (element, originalStyles, prefix) => {
      // Restore background
      element.style.backgroundColor = originalStyles[`${prefix}_bg`] || "";
      element.style.backgroundImage = originalStyles[`${prefix}_bgImg`] || "";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
      });
    };

    // Store original styles and make all elements transparent
    const originalStyles = {};
    makeTransparent(gridElement, originalStyles, "root");

    // Add a temporary style tag with aggressive selectors
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: white !important;
        background-image: none !important;
        background: white !important;
        fill: transparent !important;
        color: black !important;
        padding-left: 13px;
      }
      .flexLabel{
        padding-left: 15px;
      }
      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
    document.head.appendChild(styleTag);

    // If this is a Kendo chart, try to update its options directly
    if (this._chart && typeof this._chart.setOptions === "function") {
      try {
        const currentOptions = this._chart.options || {};
        this._chart.setOptions({
          ...currentOptions,
          chartArea: {
            ...currentOptions.chartArea,
            background: "transparent",
          },
          plotArea: {
            ...currentOptions.plotArea,
            background: "transparent",
          },
        });
      } catch (e) {
        console.error("Error updating chart options:", e);
      }
    }

    // Force a repaint
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";

    // setTimeout(async () => {
    drawDOM(gridElement, {
      background: "transparent"
    })
      .then((group) => {
        // Try to modify the group to ensure transparency
        try {
          if (group && group.children) {
            group.children.forEach((child) => {
              if (child.options) {
                child.options.background = "transparent";
              }
            });
          }
        } catch (e) {
          console.error("Error modifying group:", e);
        }

        return exportImage(group, {
          background: "transparent"
        });
      })
      .then((dataURI) => {
        saveAs(dataURI, widgetName + ".png");
      })
      .catch((error) => {
        console.error("PNG export error:", error);
        // If transparent export fails, try with white background
        drawDOM(gridElement, {
          background: "white"
        })
          .then((group) => exportImage(group, { background: "white" }))
          .then((dataURI) => {
            saveAs(dataURI, widgetName + ".png");
          })
          .catch((fallbackError) => {
            console.error("Fallback PNG export error:", fallbackError);
          });
      })
      .finally(() => {
        // Clean up - remove the style tag
        document.head.removeChild(styleTag);

        // Restore original backgrounds
        restoreBackgrounds(gridElement, originalStyles, "root");

        // If we modified the chart options, try to restore them
        if (this._chart && typeof this._chart.setOptions === "function") {
          try {
            this._chart.refresh();
          } catch (e) {
            console.error("Error refreshing chart:", e);
          }
        }

        if (narrativeElement) {
          // After export, hide the element
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
    // }, 1000);
  };

  onPDFExportClick = (flag) => {
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "KPI";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);

    //================ Export Narrative Start =========================
    // 1. Find the .textnarrativeexport inside this chart
    let narrativeElement = gridElement.querySelector(".textnarrativeexport");

    if (narrativeElement) {
      // 2. Temporarily make it visible
      narrativeElement.style.display = "block";

      // 3. Assign new text value inside the <p> tag
      let pTag = narrativeElement.querySelector("p");
      if (pTag) {
        const narrativeText = this.state.chartData?.textNarrative || "";
        pTag.textContent = narrativeText;
      }
    }
    //================ Export Narrative End ===========================

    //================ transparency Start ===========================

    // Function to recursively set background to transparent for all elements
    const makeTransparent = (element, originalStyles, prefix) => {
      // Store original background
      originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
      originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

      // Set background to transparent
      element.style.backgroundColor = "transparent";
      element.style.backgroundImage = "none";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        makeTransparent(child, originalStyles, `${prefix}_${index}`);
      });

      return originalStyles;
    };

    // Function to restore original backgrounds
    const restoreBackgrounds = (element, originalStyles, prefix) => {
      // Restore background
      element.style.backgroundColor = originalStyles[`${prefix}_bg`] || "";
      element.style.backgroundImage = originalStyles[`${prefix}_bgImg`] || "";

      // Process all child elements
      Array.from(element.children).forEach((child, index) => {
        restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
      });
    };

    // Store original styles and make all elements transparent
    const originalStyles = {};
    makeTransparent(gridElement, originalStyles, "root");

    // Add a temporary style tag with aggressive selectors
    const styleTag = document.createElement("style");
    styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: transparent !important;
        background-image: none !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
         padding-left: 8px;
      }
      .flexLabel{
        padding-left: 17px !important;
      }
      
         .wgHeader{
        padding-left: 10px !important;
        }
      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
        // padding-left: 17px !important;
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
    document.head.appendChild(styleTag);

    // If this is a Kendo chart, try to update its options directly
    if (this._chart && typeof this._chart.setOptions === "function") {
      try {
        const currentOptions = this._chart.options || {};
        this._chart.setOptions({
          ...currentOptions,
          chartArea: {
            ...currentOptions.chartArea,
            background: "transparent",
          },
          plotArea: {
            ...currentOptions.plotArea,
            background: "transparent",
          },
        });
      } catch (e) {
        console.error("Error updating chart options:", e);
      }
    }

    // Force a repaint
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";
    //================ transparency End ===========================

    // setTimeout(async () => {
    drawDOM(gridElement, {
      // landscape: false,
      title: this.state.title + " " + CreatedDate,
      background: "transparent",
      // paperSize: "auto",
      // margin: "1cm",
      // scale: 0.8,
      // forcePageBreak: ".page-break",
    })
      .then((group) => {
        // Try to modify the group to ensure transparency
        try {
          if (group && group.children) {
            group.children.forEach((child) => {
              if (child.options) {
                child.options.background = "transparent";
              }
            });
          }
        } catch (e) {
          console.error("Error modifying group:", e);
        }

        return exportPDF(group, {
          background: "transparent",
          // paperSize: "auto",
          // margin: "1cm",
          // landscape: true,
        });
      })
      .then((dataURI) => {
        if (flag === "MAIL") {
          this.sendMail(dataURI, chartId);
        } else if (flag !== "INIT") {
          saveAs(dataURI, widgetName + ".pdf");
        }
      })
      .catch((error) => {
        console.error("PDF export error:", error);
      })
      .finally(() => {
        // Clean up - remove the style tag
        document.head.removeChild(styleTag);

        // Restore original backgrounds
        restoreBackgrounds(gridElement, originalStyles, "root");

        // If we modified the chart options, try to restore them
        if (this._chart && typeof this._chart.setOptions === "function") {
          try {
            this._chart.refresh();
          } catch (e) {
            console.error("Error refreshing chart:", e);
          }
        }

        if (narrativeElement) {
          // 5. After export, remove the temporary text or hide the element
          narrativeElement.style.display = "none";
          let pTag = narrativeElement.querySelector("p");
          if (pTag) {
            pTag.textContent = ""; // clear the text if needed
          }
        }
      });
    // }, 1000);

    // this.pdfTitlePopupClose();
  };

  ViewDataSet = () => {
    this.setState({
      visible: true,
    });
  };

  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };

  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative && this.props.refreshTextNarative(text, widgetId);
  };

  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };

  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else if (chartData.isTaskModuleDisabled) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>
          <h4 className="wgTitle">
            Cannot load report as Task Module settings have been changed for
            Tenant. Please contact administrator.
          </h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else {
      return (
        <div>
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}

          {this.state.visible && (
            <Window
              title={chartData.dataSource}
              onClose={this.closeToggleClose}
              className="statusWindow"
              initialLeft={350}
              initialTop={200}
              initialWidth={1000}
              initialHeight={490}
            >
              <div className="tblCont dataGrids">
                <ViewActionRiskDataset
                  chartData={chartData}
                  isFreezeDS={this.props.isFreezeDS}
                ></ViewActionRiskDataset>
              </div>
            </Window>
          )}

          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}
          {this.props.flag ? (
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                  <li onClick={() => this.editWidgetOpen(chartData)}>
                    <a>
                      <img src={Images.EDITICON} alt="Edit" width="14" />
                    </a>
                  </li>
                )
                : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
              <li title="Add to home" onClick={() => this.moveToHome(chartData)}>
                <a>
                  <img src={Images.HOME} alt="Download" width="14" />
                </a>
              </li>
              <li title="PNG Download" onClick={this.onImageExportClick}>
                <a>
                  <img src={Images.DOWNLOAD} alt="Download" width="14" />
                </a>
              </li>
              <li title="PDF Download" onClick={this.onPDFExportClick}>
                <a>
                  <img src={Images.PDF} alt="Download" width="14" />
                </a>
              </li>
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Share"
                  onClick={() => this.openAddToCart(chartData.widgetId)}
                >
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Mail"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.onPDFExportClick("MAIL")}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? this.props.isFreezeDS
                  ? ""
                  : !this.props.isFreezeDS && (
                    <li onClick={this.openWidgetDeletePopup}>
                      <a className="bgRed">
                        <img src={Images.TRASH} alt="Trash" width="13" />
                      </a>
                    </li>
                  )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions"></ul>
          )}

          {this.props.viewDataSetIcon && (
            <ul className="viewDataset WidgetActions">
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
            </ul>
          )}
          <div id="tilechart">
            <div
              id={"c" + chartData.widgetId}
              className="textEditorClass"
              style={{ marginTop: "5px" }}
              key={chartData.title}
            >
              <p className="flexLabel" style={{ color: "white" }}>
                &nbsp; Task
              </p>

              <div id="actionrows">
                <div className="actionrow">
                  <div className="actionelemnet">
                    Total Tasks
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.ASSESSMENT} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.totalTasksCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Open Tasks
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.openTasksCount
                          : 0}{" "}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Closed Tasks
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.CLOSEDRISK} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.closedTasksCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="actionrow">
                  <div className="actionelemnet">
                    Original Overdue Tasks
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.ASSESSMENT} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.overdueTaskCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Projected Overdue Tasks
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.projectedOverdueTaskCount
                          : 0}{" "}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="actionrow">
                  <div className="actionelemnet" >
                    Total Tasks Effort {" (Days)"}
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? formatNumber(
                            this.state.tasksMetricsResponse
                              .totalTaskEffort,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "24px" }}>
                    Total Tasks Cost
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {secureLocalStorage.getItem("currency")}
                        {"  "}
                        {this.state.tasksMetricsResponse
                          ? formatNumber(
                            this.state.tasksMetricsResponse
                              .totalTaskCost,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  {/* <div className="actionelemnet" style={{ paddingLeft: "24px" }}>
                  Unapproved Tasks Effort {" (Days)"}
                  <div className="row">
                    <div className="iconBox">
                      <img
                        src={Images.CHECKCIRCLE}
                        width="16"
                        alt="Dashboard"
                      />
                    </div>
                    <h4>
                      {this.state.tasksMetricsResponse
                        ? formatNumber(
                            this.state.tasksMetricsResponse
                              .unApprovedTaskEffort,
                            "##,#"
                          )
                        : 0}
                    </h4>
                  </div>
                </div>
                <div className="actionelemnet" style={{ paddingLeft: "65px" }}>
                  Approved Tasks Effort {" (Days)"}
                  <div className="row">
                    <div className="iconBox">
                      <img
                        src={Images.CHECKCIRCLE}
                        width="16"
                        alt="Dashboard"
                      />
                    </div>
                    <h4>
                      {this.state.tasksMetricsResponse
                        ? formatNumber(
                            this.state.tasksMetricsResponse
                              .approvedTaskEffort,
                            "##,#"
                          )
                        : 0}
                    </h4>
                  </div>
                </div> */}
                </div>
                <div className="actionrow">
                  <div className="actionelemnet" style={{ whiteSpace: "nowrap" }}>
                    % of fields completed
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.TYPES} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse
                            .taskFieldPercentageCompletion
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ whiteSpace: "nowrap" }}>
                    Tasks Completed On Time
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.TYPES} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.tasksMetricsResponse
                          ? this.state.tasksMetricsResponse.tasksCompletedOnTime
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>

              </div>
              {/*  */}
              <p className="flexLabel" style={{ color: "white" }}>
                &nbsp; Activity
              </p>

              <div id="actionrows">
                <div className="actionrow">
                  <div className="actionelemnet">
                    Total Activities
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.ASSESSMENT} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .totalTaskActionCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "20px" }}>
                    Open Activities
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .openTaskActionCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Closed Activities
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.CLOSEDRISK} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .closedTaskActionCount
                          : 0}
                      </h4>
                    </div>
                  </div>

                </div>
                <div className="actionrow">
                  <div className="actionelemnet">
                    Original Overdue Activities
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .overdueTaskActionCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Projected Overdue Activities
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .projectedOverdueTaskActionCount
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="actionrow">
                  <div className="actionelemnet" >
                    Total Activities Effort {" (Days)"}
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .totalTaskActionEffort,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "24px" }}>
                    Unapproved Activities Effort {" (Days)"}
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .unApprovedTaskActionEffort,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "65px" }}>
                    Approved Activities Effort {" (Days)"}
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .approvedTaskActionEffort,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="actionrow">
                  <div className="actionelemnet">
                    % of fields completed
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .taskActionFieldPercentageCompletion
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet">
                    Activities Completed On Time
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {this.state.taskActionsMetricsResponse
                          ? this.state.taskActionsMetricsResponse
                            .taskActionsCompletedOnTime
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              {/*  */}
              <p className="flexLabel" style={{ color: "white" }}>
                &nbsp; Activity Cost
              </p>
              <div id="actionrows">
                <div className="actionrow">
                  <div className="actionelemnet">
                    Total Activities Cost
                    <div className="row">
                      <div className="iconBox">
                        <img src={Images.UNAPPROVE} width="16" alt="Dashboard" />
                      </div>
                      <h4>
                        {secureLocalStorage.getItem("currency")}
                        {"  "}
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .totalTaskActionCost,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "24px" }}>
                    Unapproved Activities Cost
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {secureLocalStorage.getItem("currency")}
                        {"  "}
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .unApprovedTaskActionCost,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                  <div className="actionelemnet" style={{ paddingLeft: "24px" }}>
                    Approved Activities Cost
                    <div className="row">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <h4>
                        {secureLocalStorage.getItem("currency")}
                        {"  "}
                        {this.state.taskActionsMetricsResponse
                          ? formatNumber(
                            this.state.taskActionsMetricsResponse
                              .approvedTaskActionCost,
                            "##,#"
                          )
                          : 0}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="wgHeader">
                <h4>Dataset: {chartData.dataSource} </h4>
              </div>
              <TextNarrativeExport chartData={chartData} isHidden={this.state.isHidden} />
            </div>
          </div>
          <ReportUpdate
            chartData={chartData}
            ref="childUpdateWidget"
            updateChartData={this.updateChartData}
          />
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
          <Popup
            show={this.state.openPdfTitlePopup}
            popupClass={"popup-content"}
          >
            {this._Loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="addTypeForm">
              <div className="fieldCont">
                <label>Enter Title</label>
                <input
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                  placeholder="Title"
                  value={this.state.title}
                  required
                />
              </div>
              <div className="btnGroup">
                <button
                  disabled={!this.state.title}
                  className="btnPrimary"
                  onClick={this.onPDFExportClick}
                >
                  Export
                </button>
                <button className="btnDark" onClick={this.pdfTitlePopupClose}>
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>
        </div>
      );
    }
  }
}
